import React from "react";

const InputField = React.forwardRef(
  (
    {
      value,
      onChange,
      onFocus,
      formatType,
      placeholder,
      focused,
      className = "",
    },
    ref
  ) => {
    let formattedValue;
    let totalLength;

    if (formatType === "card") {
      formattedValue = value
        .replace(/\D/g, "")
        .replace(/(.{4})/g, "$1 ")
        .trim();
      totalLength = 19;
    } else if (formatType === "date") {
      formattedValue = value.replace(/\D/g, "");

      if (formattedValue.length >= 2) {
        formattedValue =
          formattedValue.slice(0, 2) + "/" + formattedValue.slice(2, 4);
      }
      totalLength = 5;
    } else if (formatType === "num") {
      totalLength = 1;
      formattedValue = value;
    } else {
      formattedValue = value;
      totalLength = 3;
    }

    return (
      <input
        ref={ref}
        type="text"
        value={formattedValue}
        onChange={onChange}
        onFocus={onFocus}
        inputMode="numeric"
        maxLength={totalLength}
        placeholder={placeholder}
        className={[
          // базовые стили
          " mt-2 w-full rounded-xl border border-[#DFE6EE] bg-white px-4 py-3.5 text-sm text-[#263B51] outline-none transition-colors duration-300 placeholder:text-[#8A97A8] focus:border-[#0752AA] focus:ring-2 focus:ring-[#0752AA]/10",
          
          // можно переопределять снаружи
          className,
        ].join(" ")}
      />
    );
  }
);

export default InputField;
